// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { Alert } from '@mui/material';
import { AppIcon } from '@shared/ui-kit/components';
import { Translation } from '@shared/ui-kit/providers';
import { defineComponent } from '@shared/ui-kit/utils/define-component';

interface ProfileExpirationAlertProps {
  profileExpirationDate: string | null;
}

export const ProfileExpirationAlert = defineComponent({
  displayName: 'ProfileExpirationAlert',
  useSetup: ({ profileExpirationDate }: ProfileExpirationAlertProps) => ({
    profileExpirationDate,
  }),
  View: ({ profileExpirationDate }) => {
    if (!profileExpirationDate) {
      return null;
    }

    return (
      <Alert
        icon={<AppIcon icon="Info" size="lg" color="main" />}
        severity="info"
        className="mb-6 !rounded-lg"
        data-testid="profile-expiration-alert"
      >
        <Translation
          i18nKey="onboarding-process-overview.result-and-signature.profile-expiration.message"
          ns="components"
          values={{ date: profileExpirationDate }}
          components={{
            strong: <strong />,
          }}
        />
        <br />
        <Translation
          i18nKey="onboarding-process-overview.result-and-signature.profile-expiration.modify-profile"
          ns="components"
        />
      </Alert>
    );
  },
});
